// Helper to format ID number consistently
export function formatIdNumberValue(value: string): string {
  let formattedValue = '';
  for (let i = 0; i < value.length; i++) {
    if (i === 6 || i === 10) {
      formattedValue += ' ';
    }
    formattedValue += value[i];
  }
  return formattedValue;
}

export function countAddedSpaces(cursorPos: number): number {
  let spaces = 0;
  if (cursorPos > 6) spaces++;
  if (cursorPos > 10) spaces++;
  return spaces;
}

// Convert phone number field cursor position in displayed value to position in raw value
export function getCursorPositionInRawValue(formattedValue: string, cursorPos: number): number {
  // Count spaces before cursor position
  let spacesBeforeCursor = 0;
  for (let i = 0; i < cursorPos; i++) {
    if (formattedValue[i] === ' ') spacesBeforeCursor++;
  }

  return cursorPos - spacesBeforeCursor;
}

// Calculate phone number field cursor position in newly formatted value
export function getNewCursorPosition(digitsOnly: string, cursorPosInRawValue: number): number {
  // Add spaces for cursor position calculation
  let newCursorPos = cursorPosInRawValue;

  // If cursor is after position 2, add 1 for the space
  if (cursorPosInRawValue > 2) newCursorPos++;

  // If cursor is after position 5, add 1 for the second space
  if (cursorPosInRawValue > 5) newCursorPos++;

  // Ensure cursor position is valid
  return Math.min(newCursorPos, formatWithSpaces(digitsOnly).length);
}

// Format a string of digits with spaces (XX XXX XXXX)
export function formatWithSpaces(digits: string): string {
  if (!digits) return '';

  let result = '';

  // First chunk (2 digits)
  if (digits.length > 0) {
    result += digits.substring(0, Math.min(2, digits.length));
  }

  // Second chunk (3 digits)
  if (digits.length > 2) {
    result += ' ' + digits.substring(2, Math.min(5, digits.length));
  }

  // Third chunk (remaining digits)
  if (digits.length > 5) {
    result += ' ' + digits.substring(5);
  }

  return result;
}

// Filter out special characters and numbers (keeps only letters, spaces, and hyphens)
export function filterLettersOnly(value: string): string {
  return value.replaceAll(/[^a-zA-Z\s-]/g, '');
}

// Convert the first 6 digits (YYMMDD) of a South African ID number into an ISO date string (YYYY-MM-DD).
// Century is inferred from the YY value: 00-29 => 2000s, 30-99 => 1900s.
export function getDateOfBirthFromSaIdNumber(idNumber: string): string | null {
  if (!idNumber) return null;

  const digits = idNumber.replaceAll(/\s/g, '');
  if (digits.length < 6 || !/^\d{6}/.test(digits)) return null;

  const yy = Number(digits.substring(0, 2));
  const month = digits.substring(2, 4);
  const day = digits.substring(4, 6);

  const monthNum = Number(month);
  const dayNum = Number(day);
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) return null;

  const century = yy <= 29 ? 2000 : 1900;
  const year = century + yy;

  return `${year}-${month}-${day}`;
}
